import axios from "../../components/shared/axios"
import { actions } from "../graphics_menu";

const fetchGraphics = async (state, dispatch) => {
  const result = await axios.get(`${state.basepath}/graphics.json`)

  dispatch({
    type: actions.SET_GRAPHICS,
    payload: result.data.graphics.data,
  })
}

export { fetchGraphics }
